export default __webpack_public_path__ + "static/media/coffee-recipe-app.a3e066e0.jpeg";